let pendingPurchaseAction: string | null = null;

export const setPendingSubscriptionPurchaseAction = (action: string | null | undefined) => {
  if (typeof action === "string") {
    const normalized = action.trim();
    pendingPurchaseAction = normalized.length > 0 ? normalized : null;
    return;
  }
  pendingPurchaseAction = null;
};

export const consumePendingSubscriptionPurchaseAction = (): string | null => {
  const action = pendingPurchaseAction;
  pendingPurchaseAction = null;
  return action;
};
